import React from 'react'
import navdbg from '../assests/navdbg.png'
function NavbarBottom() {
  return (
    <div className='w-full h-[760px] bg-slate-700   '>
            <div className='absolute bottom-0 right-0'><img src={navdbg} alt='nav down' className='items-end'/></div>
    </div>
  )
}

export default NavbarBottom
